import React from 'react';
import styled from 'styled-components';

interface MobileDashboardCardsLayoutProps {
  children: React.ReactNode;
}

const MobileDashboardCardsLayout: React.FC<MobileDashboardCardsLayoutProps> = ({ children }) => (
  <Layout>{children}</Layout>
);

export default MobileDashboardCardsLayout;

const Layout = styled.div`
  display: grid;
  gap: 16px;
  grid-template-columns: 1fr;
`;
